import axios from "axios";
import {getServerEndPoint} from "../liveshows/webEndPoint";
import {genreChannelsList} from "../liveshows/channelGenre";

const getLiveTokenChannel = async () => {
    const initialTV = (await axios.get(getServerEndPoint() + "api/initialTV")).data
    const outData = initialTV?.ServiceResponse?.OutData
    window.localStorage.setItem("LiveToken", outData?.LiveToken)
    window.localStorage.setItem("RMUToken", outData?.RMUToken)
    window.localStorage.setItem("TokenCreatedDate", new Date().getTime().toString())
    return outData
}
const reInitialTv = async () => {
    const outData = await getLiveTokenChannel()
    let channelsData = []
    for (let channelGroups of outData?.PDS?.ChannelsGroups?.ChannelsGroup) {
        for (let channel of channelGroups?.Channels) {
            if (channel.AccessRights?.NoAccess === "false") {
                channelsData.push(channel)
            }
        }
    }
    window.localStorage.setItem("Channels", JSON.stringify(channelsData))
    return channelsData
}

const getEventShows = async () =>{

    await reInitialTv()
    /*
    const tokenLive = window.localStorage.getItem("LiveToken")
    if(!tokenLive){
        await reInitialTv()
    }
    else  {
        const createdLiveTokenDate = window.localStorage.getItem("TokenCreatedDate")
        if(createdLiveTokenDate){
            const tokenLiveDate = new Date(parseInt(createdLiveTokenDate));
            const endingDate =  tokenLiveDate.setHours(tokenLiveDate.getHours() + 1) ;
            const nowTimeDate = new Date().getTime()
            if(endingDate< nowTimeDate){
                await reInitialTv()
            }
        }
    }
    */
    const eventShows = (await axios.get(getServerEndPoint() + "api/liveShows")).data
    return eventShows?.channels
}

/**
 * filter of the genre of Channels
 * @param genreName the Genre to be research
 * @param channels List of Channels
 * @returns {*} a List of channels depending on the Genre
 */
const getChannelGenre = (id, channels) => {
    const genreNameList = genreChannelsList().filter((channel)=> channel.id === parseInt(id))
    if(genreNameList.length === 1){
        const genreName = genreNameList.at(0).name
        return  channels.filter((channel) => channel?.Them.toLowerCase().includes(genreName.toLowerCase()))
    }

}

export { getEventShows, getChannelGenre}